
//Incase emergency, swap strings :) 
const FetchVariable = {
    Local: 'http://localhost:3308',
    Heroku: 'https://cis-4375-backend.herokuapp.com'
}

export { FetchVariable };

